<template>
  <footer>
    <div class="wrapper">
      <div class="footer__content">
        <div>
          <img
            alt="image"
            src="@/assets/img/svg/main-white.svg"
            style="cursor:pointer"
            class="new-logo newheader__logo"
            @click="$router.push({ name: 'Main' })"
          />
        </div>

        <div class="footer__left">
          <a class="socials">
            <div class="jabber">
              <img
                alt="image"
                src="@/assets/img/svg/jabber-icon.svg"
              />
            </div>
          </a>
          <a class="socials">
            <div class="tg">
              <img
                alt="image"
                src="@/assets/img/svg/tg-icon.svg"
              />
            </div>
          </a>
          <a class="socials">
            <div class="mail">
              <img
                alt="image"
                src="@/assets/img/svg/mail-icon.svg"

              />
            </div>
          </a>
          <a class="socials">
            <div class="vk">
              <img
                alt="image"
                src="@/assets/img/svg/vk-icon.svg"

              />
            </div>
          </a>
          <a class="socials">
            <div class="blogger">
              <img
                alt="image"
                src="@/assets/img/svg/blogger-icon.svg"
              />
            </div>
          </a>
        </div>

        <div class="copyrights">
          <p class="copyright__text">Copyrights © 2024 BlitzBit</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState, mapActions } from "vuex";
//
export default {
  name: "Footer",

  computed: {
    ...mapState("auth", ["token", "login"]),
    ...mapState("info", ["info"])
  },

  methods: {
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["userLogin", "userRegister"]),

    Login() {
      this.openModal({
        name: "login",
        success: this.userLogin
      });
    },

    Register() {
      this.openModal({
        name: "register",
        success: this.userRegister
      });
    }
  }
};
</script>

<style scoped>
.footer__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nav {
  font-weight: 700;
}
.jabber {
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #1461b9;
  border: 2px solid #0b3d76;
}
.tg {
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #229ed9;
  border: 2px solid #1577a6;
}
.vk {
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #4c75a3;
  border: 2px solid #305175;
}
.blogger {
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f89500;
  border: 2px solid #bf7300;
}
.mail {
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f80000;
  border: 2px solid #b10505;
}
.navs-wrapper {
  display: flex;
  gap: 24px;
  margin-bottom: 25px;
  margin-top: 25px;
}
.nav link {
  font-size: 15px;
  font-weight: 700;
}
.footer__left {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 70%;
  gap: 10px;
  align-items: center;
}
.socials {
  width: fit-content;
}
.copyrights {
  margin-top: 20px;
}
.copyright__text {
  color: #484644;
  font-size: 17px;
  font-weight: 500;
}
.footer__right {
  display: flex;
  align-items: center;
}
.footer__right > *:not(:last-child) {
  margin-right: 30px;
}

.icon-vk svg {
  display: inline-block;
  fill: #74dbef;
  height: 25px;
  width: 25px;
}
footer .header__top_wrapper.--social {
  flex-direction: column;
  align-items: center;
  height: auto;
}
footer .header__top_wrapper.--social .header__social:first-of-type {
  margin-top: 10px;
  margin-bottom: 20px;
}

@media screen and (max-width: 615px) {
  .footer__content {
    flex-direction: column;
  }
  .footer__right {
    margin-top: 30px;
  }
  .footer__right > a > img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Footer.vue